<template>
  <!-- <label v-if="label" class="inp-label">
    {{ label }}
  </label> -->
  <span :class="['search-title', labelClass]">{{ label }}</span>
  <ul :class="['search-rdo-box', searchClass]">
    <li class="search-rdo" :class="{ active: activePreset === 1 }">
      <input type="radio" name="searchRdo" v-model="selectedMonth" @click="setPreset(1)" />
      <label for="test1"> 1개월 </label>
    </li>
    <li class="search-rdo" :class="{ active: activePreset === 3 }">
      <input type="radio" name="searchRdo" v-model="selectedMonth" @click="setPreset(3)" />
      <label> 3개월 </label>
    </li>
    <li class="search-rdo" :class="{ active: activePreset === 6 }">
      <input type="radio" name="searchRdo" v-model="selectedMonth" @click="setPreset(6)" />
      <label> 6개월 </label>
    </li>
    <li class="search-rdo" :class="{ active: activePreset === 12 }">
      <input type="radio" name="searchRdo" v-model="selectedMonth" @click="setPreset(12)" />
      <label> 12개월 </label>
    </li>
  </ul>
  <div :class="['datepicker-wrap', datePickerClass]">
    <HconComPCDatepicker :range="true" v-model="dateRange" :resetPostion="resetPostion" placeholder="날짜" />
  </div>
</template>
<script lang="ts" setup>
import HconComPCDatepicker from '@/components/com/HconComPCDatepicker.vue';
import { ref, onMounted } from 'vue';

const dateRange = defineModel<[Date, Date] | null>();
const selectedMonth = ref<number | null>(null);
const activePreset = ref<number | null>(null); // 버튼 활성화 관리 preset
const isApplyingPreset = ref(false); // preset 으로 dateRange 변경 중인지 구분하는 플래그

defineProps({
  label: {
    type: String,
    default: '검색일자'
  },
  labelClass: {
    type: String,
    default: ''
  },
  searchClass: {
    type: String,
    default: ''
  },
  datePickerClass: {
    type: String,
    default: 'ml20'
  },
  resetPostion: {
    type: Boolean,
    default: true
  }
});

const emit = defineEmits<{
  (e: 'update:modelValue', value: [Date, Date] | null) : void
}>();

const setRange = (months: number): [Date, Date] => {
  const today = new Date();
  const startDate = new Date();

  startDate.setMonth(today.getMonth() - months);

  return [startDate, today];
}

const setPreset = (months: number) => {
  isApplyingPreset.value = true;

  activePreset.value = months;
  dateRange.value = setRange(months);

  setTimeout(() => {
    isApplyingPreset.value = false;
  });
}

const isSameRange = (a: [Date, Date], b: [Date, Date]) => {
  return (
    a[0].toDateString() === b[0].toDateString() && a[1].toDateString() === b[1].toDateString()
  );
}

// (cow) 초기 값 세팅
onMounted(() => {
  setPreset(1); // 최근 1개월
});

// 달력 직접 조작 시 preset 해제
watch(dateRange, (newRange) => {
  if (!newRange) return;

  // preset 으로 변경 중이면 패스
  if (isApplyingPreset.value) return;

  const presets = [1, 3, 6, 12];
  for (const months of presets) {
    const presetRange = setRange(months);

    if(isSameRange(newRange, presetRange)) {
      activePreset.value = months;
      return;
    }
  }

  activePreset.value = null;
});

</script>
<style lang="scss" scoped>
@use '@/assets/scss/pc/common/variables-hcon.scss' as v;

.search-title {
  min-width: 110px;
  flex-basis: min-content;
  font-size: 15px;
  font-weight: 500;
}

.search-rdo-box {
  display: flex;
  border: 1px solid #999;
  border-radius: 8px;

  .search-rdo {
    position: relative;
    width: 100%;
    height: 40px;
    display: flex;

    &.active {
      input[type="radio"] {   
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 40px;
        margin: 0;
        cursor: pointer;  

        + label {
          outline: 1px solid v.$primary-color;
          color: v.$primary-color;
          width: 100%;
          height: 100%;
          align-content: center;
          text-align: center;

          &::after {
            outline: 1px solid v.$primary-color;
          }
        }
      }
    }
    
    &:not(:last-child) {
      border-right: 1px solid #999;
    }

    &:first-child {
      label {
        border-radius: 8px 0 0 8px;
      }
    }

    &:last-child {
      label {
        border-radius: 0 8px 8px 0;
      }
    }

    label {
      display: inline-block;
      align-content: center;
      width: 100%;
      height: 100%;
      background-color: v.$white-color;
      text-align: center;
    }

    input[type="radio"] {
      position: absolute;
      opacity: 0;
      width: 100%;
      height: 40px;
      margin: 0;
      cursor: pointer;
    }
  }
}

.datepicker-wrap {
  width: 100%;
}

.popup-content {
  .search-rdo-box{
    .search-rdo {
      width: 66px;
      font-size: 14px;
    }
    input[type="radio"] {
      width: 66px;
    }
  }
}
</style>